import { render, staticRenderFns } from "./SystemLogManagement.vue?vue&type=template&id=bb0c677c&scoped=true&"
import script from "./SystemLogManagement.vue?vue&type=script&lang=js&"
export * from "./SystemLogManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c677c",
  null
  
)

export default component.exports